import React from 'react';

/** REP-V2 — Dashboard (aligné stock / POS / activité). */
export const DASH_PANEL = 'rounded-xl border border-white/10 bg-[#151820]';
export const DASH_KPI = `${DASH_PANEL} p-3 sm:p-4`;
export const DASH_BTN_PRIMARY =
  'inline-flex items-center justify-center gap-2 px-4 py-2.5 min-h-[44px] rounded-lg bg-red-600 hover:bg-red-500 text-white font-bold text-sm transition-colors disabled:opacity-40';
export const DASH_BTN_SECONDARY =
  'inline-flex items-center justify-center gap-2 px-4 py-2.5 min-h-[44px] rounded-lg border border-white/10 bg-black/20 text-gray-300 hover:border-white/20 hover:text-white font-semibold text-sm transition-colors';
export const DASH_LINK =
  'inline-flex items-center gap-2 px-4 py-2.5 min-h-[44px] rounded-lg border border-white/10 bg-black/20 text-gray-300 hover:border-red-500/30 hover:text-white text-sm font-semibold transition-colors';
export const DASH_LINK_ACTIVE =
  'inline-flex items-center gap-2 px-4 py-2.5 min-h-[44px] rounded-lg border border-red-500/40 bg-red-950/30 text-red-300 text-sm font-semibold transition-colors hover:bg-red-950/50';
export const DASH_CTA =
  'flex flex-col items-center justify-center p-8 sm:p-10 rounded-xl border-2 border-red-500/40 bg-red-950/20 hover:bg-red-950/30 hover:border-red-500/60 transition-colors text-center';

export const DashboardKpi = ({ icon: Icon, value, label, accent = 'text-red-400', testId }) => (
  <div className={DASH_KPI} data-testid={testId}>
    {Icon && <Icon className={`w-4 h-4 mb-2 ${accent}`} />}
    <div className="text-2xl font-black tabular-nums text-white">{value ?? '—'}</div>
    <div className="text-[10px] sm:text-xs text-gray-500 uppercase tracking-wide mt-0.5">{label}</div>
  </div>
);

export const DashboardSectionTitle = ({ title, subtitle }) => (
  <div className="mb-1">
    <h2 className="text-xl sm:text-2xl font-bold text-white tracking-tight">{title}</h2>
    {subtitle && <p className="text-xs sm:text-sm text-gray-500 mt-1">{subtitle}</p>}
  </div>
);
